import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2'; // optional for confirmation popup

@Component({
  selector: 'app-most-view-books',
  templateUrl: './most-view-books.component.html',
  styleUrls: ['./most-view-books.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MostViewBooksComponent implements OnInit {
  public arrCoupons: any[] = [];
  currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
            private loading : LoadingService,
            private language : LanguageService,
    
    private router: Router , 
    private modal : NgbModal,
    private translate: TranslateService
  ) {
    this.currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  this.translate.onLangChange.subscribe(lang => {
    this.currentLang = lang.lang;
  });
  } 
searchValue = '';

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

   public books :any 

  public levels: any[] = [];
  public tempData = [];
  public bookDetails : any
  public lang : any

  public totalPages = 0;
public pagesToShow: number[] = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

 

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.getMostBooks();
    this.language.currentLang.subscribe((res: string) => {
      this.lang = res;
    })

  }

      /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }
 
getMostBooksss(page: number = 1) {
  this.currentPage = page; // track current page
  this.loading.show();

  this.apisService.getMostBooks(this.currentPage, this.searchValue).pipe(
    finalize(() => this.loading.hide())
  ).subscribe((res: any) => {
    this.books = res.data || [];

    // totalItems must come from API total
    // if your API does not return total, you can use a fallback like res.total || 50
    // this.totalItems = res.total || res.data.length * 5; 
    this.totalItems = res.total;

  });
}

  getMostBooks(page: number = 1) {
  this.currentPage = page;
  this.loading.show();

  this.apisService.getMostBooks(this.currentPage, this.searchValue)
    .pipe(finalize(() => this.loading.hide()))
    .subscribe((res: any) => {
      this.books = res.data || [];

      // ✅ FORCE stable pagination
      if (res.total) {
        this.totalItems = res.total;
      } else {
        // assume at least 8 pages always
        this.totalItems = Math.max(
          this.totalItems,
          this.itemsPerPage * 1000
        );
      }
    });
}




  getLevels() {
    this.apisService.users().subscribe({
      next: (response) => {
        this.levels = response.data;
        console.log(this.levels);
      },
    });
  }


onPageChange(page: number) {
  if (page === this.currentPage) return;
  this.getMostBooks(page);
}


  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

    open(content : any , row : any){ 
  this.bookDetails = row
  console.log(this.bookDetails)
  this.modal.open(content, { centered: true , size: 'lg' });
}

close(){
  this.modal.dismissAll();
}

  
  confirmDelete(id: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will delete the book permanently.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        this.apisService.deleteBooks(id).subscribe({
          next: () => {
            Swal.fire('Deleted!', 'The book has been deleted.', 'success');
            this.loadBooks(); // reload your data if needed
            this.getMostBooks(); // reload your data if needed
            this.getMostBooksss(); // reload your data if needed
          },
          error: () => {
            Swal.fire('Error!', 'Something went wrong.', 'error');
          },
        });
      }
    });
  }
 
 
  // example reload method
  loadBooks(): void {
    // your logic to refresh the table
  }
  // filterUpdate(event) {
  //   const val = event.target.value.toLowerCase();
  //   this.arrCoupons = this.tempData.filter((d) =>
  //     d.code.toLowerCase().includes(val)
  //   );
  //   this.table.offset = 0;
  // }

  filterUpdate(event: any) {
  this.searchValue = event.target.value;
  this.currentPage = 1; // مهم جدًا
  this.getMostBooks();
}

  /*----------  Pagination Functions   ----------*/
next() { 
  if (this.currentPage < this.totalPages) {
    this.getMostBooks(this.currentPage + 1);
  }
}

prev() { 
  if (this.currentPage > 1) {
    this.getMostBooks(this.currentPage - 1);
  }
}

goToPage(page: number) {
  if (page >= 1 && page <= this.totalPages) {
    this.getMostBooks(page);
  }
}

}
